import { render, staticRenderFns } from "./issuesinfo.vue?vue&type=template&id=9f92065a&scoped=true"
import script from "./issuesinfo.vue?vue&type=script&lang=js"
export * from "./issuesinfo.vue?vue&type=script&lang=js"
import style0 from "./issuesinfo.vue?vue&type=style&index=0&id=9f92065a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f92065a",
  null
  
)

export default component.exports